export const PROTFOLIO_STORE: string = 'PROTFOLIO_STORE';
